import { TFunction } from 'i18next';
import { FC } from 'react';
import { useController } from 'react-hook-form';
import { AllOptionEnum } from '../../../../../../utils';
import { InputLabel, ValidationErrorList } from '../../../../../common/Inputs';
import { Column } from '../../../../../common/LayoutComponents';
import {
  StopSearchFilters,
  StringMunicipality,
  knownMunicipalities,
} from '../../../Types';
import { stopSearchBarTestIds } from '../stopSearchBarTestIds';
import { DisableableFilterProps } from '../Types/DisableableFilterProps';
import { EnumFilter } from './EnumFilter';

type Option = StringMunicipality | AllOptionEnum.All;

const options: ReadonlyArray<Option> = [
  AllOptionEnum.All,
  ...knownMunicipalities.toSorted((a, b) => a.localeCompare(b)),
];

function uiNameMapper(t: TFunction, value: Option): string {
  if (value === AllOptionEnum.All) {
    return t(($) => $.all);
  }

  return value;
}

const defaultValue: ReadonlyArray<Option> = [AllOptionEnum.All];

export const MunicipalityFilter: FC<DisableableFilterProps> = ({
  className,
  disabled,
}) => {
  const {
    field: { onBlur, onChange, value },
  } = useController<StopSearchFilters, 'municipalities'>({
    name: 'municipalities',
    disabled,
  });

  return (
    <Column className={className}>
      <InputLabel<StopSearchFilters>
        fieldPath="municipalities"
        translationPrefix="stopRegistrySearch.fieldLabels"
      />

      <EnumFilter
        defaultValue={defaultValue}
        id="stopRegistrySearch.fieldLabels.municipalities"
        options={options}
        onBlur={onBlur}
        onChange={onChange}
        testId={stopSearchBarTestIds.municipalitiesFilter}
        uiNameMapper={uiNameMapper}
        value={value}
      />

      <ValidationErrorList<StopSearchFilters> fieldPath="municipalities" />
    </Column>
  );
};
